'use client'
import { useCheckUser, useEmailOtp, usePhoneOtp } from '@repo/services'
import { useErrorHandler, useTranslate } from '@repo/shared/hooks'
import { Button, Card, Row, Typography, toast } from '@repo/ui/components'
import { normalizeMobile } from '@repo/ui/lib'
import { useRouter } from '@repo/shared/i18n/navigation'
import { useState } from 'react'
import { ForgotPasswordForm } from './forgot-password.form'
import { ForgotPasswordOtp } from './forgot-password.otp'

export const ForgotPasswordContainer = () => {
  const [step, setStep] = useState<
    'otp' | 'change-password' | 'forgot-password'
  >('forgot-password')
  const [identifier, setIdentifier] = useState<string>('')
  const [isEmail, setIsEmail] = useState<boolean>(false)
  const [otp, setOtp] = useState<number>(0)
  const { t } = useTranslate()
  const { back } = useRouter()
  const { errorHandler } = useErrorHandler()
  const phoneOtpMutation = usePhoneOtp()
  const emailOtpMutation = useEmailOtp()
  const checkUserMutation = useCheckUser()

  const handleSubmit = (identifierValue: string, isEmailValue: boolean) => {
    setIdentifier(identifierValue)
    setIsEmail(isEmailValue)
    checkUserMutation.mutate(
      isEmailValue
        ? { email: identifierValue, phone: '' }
        : { phone: normalizeMobile(identifierValue), email: '' },
      {
        onSuccess: (res) => {
          if (!res?.exists) {
            toast.error({
              title: t('loginPage_userNotFound'),
            })
            return
          }
          if (isEmailValue) {
            emailOtpMutation.mutate(
              { email: identifierValue },
              {
                onSuccess: (res) => {
                  setOtp(res?.data?.otp ?? 0)
                  setStep('otp')
                },
                onError: errorHandler,
              },
            )
          } else {
            phoneOtpMutation.mutate(
              { phone: normalizeMobile(identifierValue) },
              {
                onSuccess: (res) => {
                  setOtp(res?.data?.otp ?? 0)
                  setStep('otp')
                },
                onError: errorHandler,
              },
            )
          }
        },
        onError: errorHandler,
      },
    )
  }

  return (
    <div className='px-md'>
      {step === 'otp' && (
        <ForgotPasswordOtp
          identifier={identifier}
          isEmail={isEmail}
          otp={otp}
          handleBack={() => setStep('forgot-password')}
        />
      )}

      {step === 'forgot-password' && (
        <Card className='p-xl rounded-sm'>
          <Row className='justify-between'>
            <Typography size='2xl' weight='bold'>
              {t('common_forgotPassword')}
            </Typography>
            <Row className='gap-xs w-fit'>
              <Button size='sm' variant='transparent' onClick={() => back()}>
                {t('common_cancellation')}
              </Button>
            </Row>
          </Row>

          <Row className='gap-md'>
            <Typography size='sm' weight='regular'>
              {t('forgotPassword_description')}
            </Typography>
          </Row>

          <ForgotPasswordForm
            onSuccess={handleSubmit}
            loading={
              phoneOtpMutation.isPending ||
              emailOtpMutation.isPending ||
              checkUserMutation.isPending
            }
          />
        </Card>
      )}
    </div>
  )
}
